module.exports = __webpack_public_path__ + "img/Elaeis_guineensis.f456ed76.jpg";